import { render } from "./MessagePage.vue?vue&type=template&id=70de3767"
import script from "./MessagePage.vue?vue&type=script&lang=js"
export * from "./MessagePage.vue?vue&type=script&lang=js"

import "./MessagePage.vue?vue&type=style&index=0&id=70de3767&lang=css"
script.render = render

export default script